import React from "react";
import { NewListDialog } from "@/dialogs/NewListDialog.tsx";
import { uiState } from "@/states.ts";
import { EditListDialog } from "@/dialogs/EditListDialog.tsx";
import { useSnapshot } from "valtio/react";
import { DeleteAccountDialog } from "@/dialogs/DeleteAccountDialog.tsx";
import { EditItemDialog } from "@/dialogs/EditItemDialog.tsx";
import { ShareListDialog } from "@/dialogs/ShareListDialog.tsx";
import { NewGroupDialog } from "@/dialogs/NewGroupDialog.tsx";
import { EditGroupDialog } from "@/dialogs/EditGroupDialog.tsx";

const Dialogs: React.FC = (props) => {
	const uiSnap = useSnapshot(uiState);

	if (uiSnap.newList) {
		return <NewListDialog />;
	} else if (uiSnap.newGroup) {
		return <NewGroupDialog />;
	} else if (uiSnap.editingGroup) {
		return <EditGroupDialog group={uiSnap.editingGroup} />;
	} else if (uiSnap.editingList) {
		return <EditListDialog list={uiSnap.editingList} />;
	} else if (uiSnap.editingItem) {
		return <EditItemDialog item={uiSnap.editingItem} />;
	} else if (uiSnap.sharingList) {
		return <ShareListDialog list={uiSnap.sharingList} />;
	} else if (uiSnap.deleteAccount) {
		return <DeleteAccountDialog />;
	}
	return null;
};

export { Dialogs };
